'use client'

import Script from 'next/script'
import {ParsedUrlQueryInput} from 'node:querystring'

interface DebugProps {
  params: ParsedUrlQueryInput
}

const Debug: React.FC<DebugProps> = ({params}) => {
  const debugConsoleActive = params.debug_console === 'true'

  if (debugConsoleActive) {
    return (
      <Script
        async
        strategy='afterInteractive'
        id='vconsole'
        src='https://unpkg.com/vconsole@latest/dist/vconsole.min.js'
        onLoad={() => {
          const w = window as any
          window.vConsole = new w.VConsole()
        }}
      />
    )
  }
  return null
}

export default Debug
